import React, { useState } from 'react'
import grievanceServices from '../grievanceServices';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import grievanceStatsServices from '../grivanceStatsServices';
import GrievanceCardList from './GrievanceCardList';
import { useAlert } from '../../../../context/AlertContext';

function UserRelatedGrievanceList({grievanceDetails}) {

	const {AppAlert} = useAlert();
	const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
	const[grievanceList,setGrievanceList] = useState(null);
	

    const getUserRelatedGrievance = () =>{
		setGrievanceList(null);
		grievanceServices.getByPhone(grievanceDetails.phone).then(res=>{
			setGrievanceList(res.data);
		}).catch(()=>{
			AppAlert("Something Went wrong, Try Again")
		})
	}




    return (
        <div className='row mt-5'>
			{ ! grievanceList && 
				<div className='col-md-12'>
					<button className='btn btn-outline-primary' onClick={getUserRelatedGrievance} >Find other grievance from this user</button>
				</div> 
			}

			{grievanceList &&
				<div className='col-md-12'>
					<GrievanceCardList grievanceList={grievanceList} getMasterLabel={getMasterLabel} />
				</div>
			}
				
			
			
		</div>
    )
}

export default UserRelatedGrievanceList